<template>
  <div id="app">
    <div id="nav">
      <router-link v-if="authenticated" to="/login" v-on:click.native="logout()" replace>Logout</router-link>
    <router-view @authenticated="setAuthenticated"  @username="setUsername" @password="setPassword"/>
  </div>
</template>

<script>
    export default {
        name: 'App',
        data() {
            return {
                authenticated: false,
                username: '',
                password: ''
            }
        },
        methods: {
            setAuthenticated(status) {
                this.authenticated = status;
            },
            setUsername(value) {
                this.username = value;
            },
            setPassword(value) {
                this.password = value;
            },
            logout() {
                this.authenticated = false;
            }
        }
    }
</script>

<style>
@import '../node_modules/buefy/dist/buefy.css'
</style>





// WEBPACK FOOTER //
// src/App.vue